import React from 'react';

interface Props {
    name: string,
    tabKey: string,
    disabled?: boolean,
    tabSelected?(tabKey: string): void,
    selectedTabKey?: string;
}

function Tab(props: Props) {
    const handleClick = () => {
        if (props.tabSelected && !props.disabled) {
            props.tabSelected(props.tabKey);
        }
    }

    const computeClassName = () => {
        let result = `tab mx-xl my-md px-sm text-p2 sm:text-h4 font-sans-co border-b-2 border-transparent`;
        result += !props.disabled ? " hover:cursor-pointer text-mid-grey" : " text-light-grey font-normal";
        if (props.selectedTabKey === props.tabKey) {
            result += " border-portal-teal text-portal-teal font-bold";
        } else if (!props.disabled) {
            result += " font-normal";
        }
        return result;
    }

    return (
        <div className={computeClassName()} id={`tab-${props.tabKey}`} onClick={handleClick}>
            {props.name}
        </div>
    )
}

export default Tab;